import { MonoTypeOperatorFunction } from 'rxjs';
import { auditTime, retryWhen } from 'rxjs/operators';

const RETRY_DELAY_MS = 5 * 1000;

export function retryWithDelay<T>(delayMs = RETRY_DELAY_MS): MonoTypeOperatorFunction<T> {
    return retryWhen((error) => {
        return error.pipe(auditTime(delayMs));
    });
}
